import api from './api';

// ==================== TYPES ====================

export interface ArticleTag {
  _id: string;
  name: string;
  slug: string;
  isActive: boolean;
  articleCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface TagsResponse {
  docs: ArticleTag[];
  totalDocs: number;
  limit: number;
  page: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface TagFormData {
  name: string;
  isActive?: boolean;
}

// ==================== API METHODS ====================

/**
 * دریافت لیست تگ‌ها
 */
export const getTags = async (
  page: number = 1,
  limit: number = 20,
  search?: string
): Promise<TagsResponse> => {
  const params: Record<string, any> = { page, limit };
  if (search) params.search = search;

  const response = await api.get('/admin/articles/tags', { params }) as any;
  return response?.data || response;
};

/**
 * ایجاد تگ جدید
 */
export const createTag = async (data: TagFormData): Promise<ArticleTag> => {
  const response = await api.post('/admin/articles/tags', data) as any;
  return response?.data || response;
};

/**
 * ویرایش تگ
 */
export const updateTag = async (id: string, data: TagFormData): Promise<ArticleTag> => {
  const response = await api.put(`/admin/articles/tags/${id}`, data) as any;
  return response?.data || response;
};

/**
 * حذف تگ
 */
export const deleteTag = async (id: string): Promise<void> => {
  await api.delete(`/admin/articles/tags/${id}`);
};
